import { render, staticRenderFns } from "./ModalChangeOrders.vue?vue&type=template&id=3060b0eb&lang=pug&"
import script from "./ModalChangeOrders.vue?vue&type=script&lang=js&"
export * from "./ModalChangeOrders.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangeOrders.vue?vue&type=style&index=0&id=3060b0eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports